<script lang="ts">
export default {
    name: 'ProductListPanelWorkspace',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import { getAppModuleService } from '@/modules/registry';
import { WORKSPACE as MODULE_WORKSPACE } from '@/modules/list';

const props = withDefaults(defineProps<{
    value?: (string | number)[];
}>(), {
    value: () => [],
});

const emit = defineEmits<{
    (event: 'input', value: (string | number)[]): void;
}>();

const list = getAppModuleService(MODULE_WORKSPACE)?.list;

const model = computed({
    get: () => props.value,
    set: value => emit('input', value),
});

function isSelected(id: string | number) {
    return model.value.some(selectedId => String(selectedId) === String(id));
}

function onSelect(id: string | number) {
    const selectedIds = model.value.filter(selectedId => String(selectedId) !== String(id));

    model.value = isSelected(id) ? selectedIds : [...selectedIds, id];
}
</script>

<template>
    <base-popover
        v-if="list?.length"
        trigger="click"
        placement="bottom-start"
    >
        <template #reference>
            <base-button
                label="Workspaces"
                size="small"
                text
                :icon="{ name: 'folder' }"
            >
                <template #suffix>
                    <div
                        v-if="value?.length"
                        v-text="value?.length"
                        class="flex h-4 min-w-4 items-center justify-center rounded-full bg-primary-600 leading-none text-white"
                    />
                    <base-icon
                        v-else
                        name="chevron-down"
                        class="text-sm -mt-0.5"
                    />
                </template>
            </base-button>
        </template>

        <div class="grid py-2">
            <div
                v-for="item in list"
                :key="item.id"
                class="flex cursor-pointer items-center gap-x-3 px-4 py-1.5 hover:bg-gray-100/50"
                @click="onSelect(item.id)"
            >
                <base-checkbox
                    class="pointer-events-none"
                    :value="isSelected(item.id)"
                />
                <div class="grid gap-0.5 select-none">
                    <span v-text="item.name" class="font-medium" />
                    <div
                        v-if="item.user"
                        class="flex items-center gap-x-2 text-gray-400"
                    >
                        <div class="text-xs">{{ item.user.name }}</div>
                        <base-icon class="text-sm" name="admin" prefix="fac" />
                    </div>
                </div>
            </div>
        </div>
    </base-popover>
</template>
